type IconProps = {
  size?: string | number;
  color?: string;
  className?: string;
};

export const PetFacilitiesIcon = ({ size = 18, color = 'currentColor', className }: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={color}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
  >
    <ellipse cx="8" cy="5" rx="2" ry="2.5" />
    <ellipse cx="16" cy="5" rx="2" ry="2.5" />
    <ellipse cx="5" cy="11" rx="2" ry="2.5" />
    <ellipse cx="19" cy="11" rx="2" ry="2.5" />
    <path d="M12 22c-3 0-5-2.5-5-5s2-4 5-4 5 1.5 5 4-2 5-5 5z" />
  </svg>
);
